import apiService from './apiService'

export const getCampaign = () => {
  return apiService.get(URIS.getActiveCampaign)
}

export const getActiveNurses = () => {
  return apiService.get(URIS.getActiveNurses)
}

export const getBookings = ({ campaignId, status , page}) => {
  const queryParams = {
    status:status,
    page: page ?? 1,
  }
  return apiService.get(URIS_D('getBookings', campaignId, ), { params: queryParams })
}
export const cancelBookings = (payload,appointmentId, campaignId) => {
  return apiService.patch(
    URIS_D('cancelBookings', campaignId, appointmentId),
    payload,
  )
}

export const bookVaccination = (payload, patientId) => {
  return apiService.post(URIS_D('bookVaccination', patientId), payload)
}

export const setToken = (payload) => {
  return apiService.post(URIS.setToken, payload)
}

export const getShifts = () => {
  return apiService.get(URIS.campaignShift)
}

export const getBookedShifts = (campaignId) => {
  const queryParams = {
    from: '2022-1-18',
    to: '',
    full: 'true',
  }
  return apiService.get(URIS_D('getBookedShift', campaignId), {
    params: queryParams,
  })
}

export const requestGetAllShifts = async (action) => {
  return await Promise.all([getShifts(), getBookedShifts(action.payload)]).then(
    (result) => result,
  )
}

export const generateSalesOrder = (campaignAppointmentId, payload) => {
  return apiService.post(
    URIS_D('generateSalesOrder', campaignAppointmentId),
    payload,
  )
}

export const requestUpdateSalesOrder = (campaignAppointmentId) => {
  return apiService.put(
    URIS_D('generateSalesOrder', campaignAppointmentId),
  )
}

export const requestConfirmSalesOrder = (campaignAppointmentId) => {
  return apiService.post(
    URIS_D('salesOrderConfirmation', campaignAppointmentId),
  )
}

export const createShift = (payload) => {
  return apiService.post(URIS.campaignShift, payload)
}

export const openCloseShift = (campaignId, payload) => {
  // {
  //   "date": "2021/12/27",
  //   "shift_id": "1",
  //   "full": true,
  //   "campaign_id": "aeaa20ab-0c39-48a7-bb6d-a14065e3dbc7"
  // }
  return apiService.post(URIS_D('getBookedShift', campaignId), payload)
}

export const deleteShift = (shiftId) => {
  return apiService.get(URIS_D('deleteShift', shiftId))
}

export const getUserInfo = (phoneNumber) => {
  const queryParams = {
    mobile: phoneNumber,
    app_user: true,
  }
  return apiService.get(URIS.getUserInfo, { params: queryParams })
}

export const requestBookCampaign = (campaignId, payload) => {
  return apiService.post(URIS_D('bookCampaigns', campaignId), payload)
}

export const requestCampaingInfo = (campaignId) => {
  return apiService.get(URIS_D('getCampaingInfo', campaignId))
}

export const requestSetTimeSlotStatus = (payload) => {
  return apiService.post(URIS_D('getBookedShift', payload.campaign_id), payload)
}

export const requestAssignCampaignToNurse = (payload) => {
  return apiService.post(
    URIS_D('assignJobs', payload.nurseId),
    payload.appointments,
  )
}

export const requestUpdateOrder = (payload) => {
  return apiService.put(
    URIS_D('updateOrder', payload.campaignId, payload.appointmentId),
    payload.order,
  )
}

export const requestNewAddress = (userId, payload) => {
  return apiService.post(URIS_D('address',userId), payload);
}

export const getUserBookedShift = (campaignId, patientId) => {
  const queryParams = {
    campaign_id: campaignId,
  }
  return apiService.get(URIS_D('bookedUserShifts', patientId), {
    params: queryParams,
  })
}

export const requestAssignCamapignToNurses = (payload) => {
  return apiService.put(URIS.assignMultiple, payload.appointments);
}


const URIS_D = (url, param1 = '', param2 = '') => {
  return {
    getBookings: `/businesses/pharmacy/campaigns/${param1}/appointments`,
    cancelBookings: `/businesses/pharmacy/campaigns/${param1}/appointments/${param2}`,
    bookVaccination: `/v1/patients/${param1}/campaign-appointments`,
    getBookedShift: `/v1/campaigns/${param1}/shifts`,
    generateSalesOrder: `/pharmacy/campaign-appointments/${param1}/sales-orders`,
    deleteShift: `/v1/campaigns/shifts/${param1}`,
    bookCampaigns: `/businesses/pharmacy/campaigns/${param1}/appointments`,
    getCampaingInfo: `/v1/campaigns/${param1}`,
    assignJobs: `/pharmacy/delivery-persons/${param1}/delivery-jobs`,
    updateOrder: `/businesses/pharmacy/campaigns/${param1}/appointments/${param2}`,
    address: `/pharmacy/customers/${param1}/addresses`,
    salesOrderConfirmation : `/pharmacy/campaign-appointments/${param1}/sales-orders/confirmation`,
    bookedUserShifts: `/v1/admin/patients/${param1}/booked-appointments`
  }[url]
}

const URIS = {
  getActiveCampaign: '/campaigns',
  getActiveNurses: '/deliveries/delivery-persons?role=NURSE',
  setToken: '/v1/payment/tokens',
  campaignShift: '/v1/campaigns/shifts',
  getUserInfo: `/pharmacy/customers/search`,
  assignMultiple: `/v1/pharmacy/campaign-jobs`,
}
